<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @openEditDialog="openEditDialog"
      />
    </page-main>
    <EditDialog
      :visible.sync="editDialogOptions.visible"
      :title="editDialogOptions.title"
      :disabled="editDialogOptions.disabled"
      :techProcessesCode="editDialogOptions.code"
      :orderCode="orderCode"
      :techCode="techCode"
      @reload="getData"
    />
  </div>
</template>
<script>
import EditDialog from './components/edit-form/dialog.vue'
import PageMain from './main'
import PageHeader from './header'
export default {
  props: {
    techCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  components: {
    PageHeader,
    PageMain,
    EditDialog,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      editDialogOptions: {
        visible: false,
        disabled: false,
        title: '',
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techCode) return
      this.loading = true
      this.$api
        .techProcessesListApi({ techCode: this.techCode })
        .then((res) => {
          this.tableData = []
          setTimeout(() => {
            this.tableData = res.body.data
          }, 0)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type = '', code = '' }) {
      const types = {
        add: this.$l('tech_processes_dialog_title_add') || '添加工艺单生产工序',
        edit:
          this.$l('tech_processes_dialog_title_edit') || '编辑工艺单生产工序',
        detail:
          this.$l('tech_processes_dialog_title_detail') || '工艺单生产工序详情',
      }
      this.editDialogOptions = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
  },
}
</script>
